import React from 'react';
import './PrivacyPolicy.css'; // Importing CSS for styling

function PrivacyPolicy() {
  return (
    <div className="privacy-policy-container" style={{ position: "relative", zIndex: 1 , backgroundColor: "white", width: "100%"}}>
      <h1>Privacy Policy</h1>
      <p>Amalgam Inc ("we", "our", or "us") is committed to protecting the privacy and security of our clients, partners, and users. This Privacy Policy explains how we collect, use, disclose, and safeguard information when you engage with our web/software development consulting services. Please read this policy carefully to understand our views and practices regarding your personal data.</p>

      <h2>1. Information We Collect</h2>
      <p>We may collect the following types of information when you interact with us or use our services:</p>
      <h3>a) Personal Information</h3>
      <p>This includes information provided by you directly, such as:</p>
      <ul>
        <li>Name, job title, and company name</li>
        <li>Contact details (email address, phone number)</li>
        <li>Billing information (payment details, billing address)</li>
      </ul>
      <h3>b) Business Information</h3>
      <p>When working with startups, we may collect business-related information, including but not limited to:</p>
      <ul>
        <li>Product ideas, project requirements, and design specifications</li>
        <li>Business models and strategies</li>
      </ul>
      <h3>c) Technical Information</h3>
      <p>This includes data automatically collected when interacting with our website or tools:</p>
      <ul>
        <li>IP address, browser type, and operating system</li>
        <li>Usage statistics and interaction data</li>
      </ul>

      <h2>2. How We Use the Information</h2>
      <p>We use the collected information for the following purposes:</p>
      <ul>
        <li>To provide and improve our consulting services</li>
        <li>To communicate with clients regarding ongoing projects</li>
        <li>To process payments and manage billing</li>
        <li>To maintain the security of our systems and protect intellectual property</li>
        <li>To comply with legal obligations</li>
      </ul>

      <h2>3. Sharing of Information</h2>
      <p>We do not sell or rent your personal or business information to third parties. However, we may share information in the following circumstances:</p>
      <ul>
        <li><strong>Service Providers:</strong> With trusted third-party service providers who assist in delivering our services (e.g., cloud hosting, payment processors), subject to confidentiality agreements.</li>
        <li><strong>Legal Compliance:</strong> If required by law or to protect the rights, property, or safety of Amalgam Inc, our clients, or others.</li>
        <li><strong>Business Transfers:</strong> In connection with any merger, sale of company assets, financing, or acquisition of all or a portion of our business by another entity.</li>
      </ul>

      <h2>4. Data Security</h2>
      <p>We implement industry-standard security measures to protect your data from unauthorized access, alteration, disclosure, or destruction. These measures include:</p>
      <ul>
        <li>Encryption of sensitive data</li>
        <li>Regular security audits and updates</li>
        <li>Access controls and authentication mechanisms</li>
      </ul>
      <p>Despite our efforts, no method of transmission over the internet or electronic storage is 100% secure, and we cannot guarantee absolute security.</p>

      <h2>5. Retention of Data</h2>
      <p>We retain personal and business information for as long as necessary to fulfill the purposes outlined in this policy, comply with legal obligations, resolve disputes, and enforce agreements. When information is no longer required, we securely delete or anonymize it.</p>

      <h2>6. Your Rights</h2>
      <p>Depending on your location and applicable laws, you may have the following rights regarding your personal data:</p>
      <ul>
        <li><strong>Access:</strong> Request a copy of the personal information we hold about you.</li>
        <li><strong>Correction:</strong> Request corrections to any inaccurate or incomplete data.</li>
        <li><strong>Deletion:</strong> Request the deletion of your personal information, subject to legal obligations.</li>
        <li><strong>Objection:</strong> Object to the processing of your data for specific purposes.</li>
      </ul>
      <p>To exercise these rights, please contact us at hello@amalgam-inc.com.</p>

      <h2>7. Third-Party Links</h2>
      <p>Our website and services may contain links to third-party websites or services. We are not responsible for the privacy practices or content of those third-party sites. We encourage you to read the privacy policies of those third-party sites before providing any personal information.</p>

      <h2>8. Changes to This Privacy Policy</h2>
      <p>We reserve the right to update this Privacy Policy at any time. When we do, we will revise the effective date at the top of this page. We encourage you to review this policy periodically to stay informed about how we are protecting your information.</p>

      <h2>9. Contact Us</h2>
      <p>If you have any questions about this Privacy Policy or our practices, please contact us at:</p>
      <p>Amalgam Inc</p>
      <p>Email: hello@amalgam-inc.com</p>
    </div>
  );
}

export default PrivacyPolicy; 